import { pick } from 'underscore';
import { cloneDeep } from '@bingads-webui-universal/primitive-utilities';
import { BaseSchemaProcessor } from './base-schema-processor';

export class ResponsiveSearchAdInstanceSchemaProcessor extends BaseSchemaProcessor {
  updateEntitySchemaForFeatures(entitySchema) {
    const updatedSchema = cloneDeep(entitySchema);

    // Only pick supported properties, ignore any properties from any pilot
    updatedSchema.properties = pick(updatedSchema.properties, [
      'Headlines',
      'Descriptions',
      'PerformanceMetricsImpressions',
    ], this.Permissions.IsResponsiveSearchAdCombGridEnabled ? [
      'PerformanceMetricsClicks',
      'PerformanceMetricsCTR',
      'PerformanceMetricsConversions',
      'PerformanceMetricsSpend',
      'PerformanceMetricsAverageCPC',
      'PerformanceMetricsAverageCPM',
      'PerformanceMetricsCPA',
      'PerformanceMetricsRevenueOnAdSpend',
      'PerformanceMetricsAdvertiserReportedRevenue',
      'PerformanceMetricsConversionRate',
    ] : [], [
      'PerformanceMetricsClicks',
      'PerformanceMetricsCTR',
      'PerformanceMetricsConversions',
      'PerformanceMetricsSpend',
    ]);

    return updatedSchema;
  }
}
